<template>

    <div class="card mb30">
        <div class="card-header">
            {{localProduct.name}}
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-3 text-center text-left-md">
                    <img v-if="product.hasOwnProperty('images')" :src="product.images[0]" class="img-fluid"
                         style='max-height: 250px;' :alt="localProduct.name">
                </div>
                <div class="col-md-9">
                    <table class="table table-sm table-striped">
                        <thead>
                        <tr class="d-flex">
                            <th class="col-xs-12 col-sm-4 col-md-6">
                                Item
                            </th>
                            <th class="col-xs-6 col-sm-4 col-md-3">
                                Price
                            </th>
                            <th class="col-xs-2 col-sm-4 col-md-3">Quantity</th>
                        </tr>
                        </thead>
                        <tbody class="merchandise__options">
                        <tr v-for="(sku, index) in localProduct.skus" class="d-flex" :key="index">
                            <td class="col-xs-12 col-sm-4 col-md-6">
                                {{sku.name}}
                            </td>
                            <td class="col-xs-6 col-sm-4 col-md-3">
                                {{sku.price.amount | money(sku.price.currency)}}
                            </td>
                            <td class="col-xs-2 col-sm-2 col-md-3">
                                <div class="input-group mb-0">

                                    <plus-minus-control
                                            class="float-right"
                                            :min="0"
                                            :max="5"
                                            v-model="sku.quantity"
                                            @decrement="decreaseQuantity(index)"
                                            @increment="increaseQuantity(index)">
                                    </plus-minus-control>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import Sku from '../../Skus/Form/Quantity';
    import PlusMinusControl from '../../AAA_TO_REFACTOR/PlusMinsControl.vue'
    import {findIndex, each} from "lodash-es"
    import {money} from '../../Utility/filters/money'

    export default {
        name: "product",
        props: {
            product: {
                type: Object,
                default: () => ({})
            },
            participant: {
                type: Object,
                default: null,
                required: false
            }
        },
        components: {
            Sku,
            PlusMinusControl
        },
        filters: {
            money,
        },
        data() {
            return {
                localProduct: {},
                skus: []
            }
        },
        created() {
            this.localProduct = JSON.parse(JSON.stringify(this.product)); //Deep copy

            this.skus = this.localProduct.skus;

            each(this.participant.orders, order => {
                const index = findIndex(this.skus, ((sku) => {
                    return sku.id === order.sku_id;
                }));

                if (index > -1) {
                    this.skus[index].quantity = order.quantity;
                }
            });
        },
        methods: {
            increaseQuantity(index) {
                this.$emit('selected', {
                    sku_id: this.skus[index].id,
                    quantity: this.skus[index].quantity
                });
            },
            decreaseQuantity(index) {
                this.$emit('selected', {
                    sku_id: this.skus[index].id,
                    quantity: this.skus[index].quantity
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/Assets/components/Products/Form/Default.vue